'use client';

import { FC } from 'react';
import { LandingReviewBlockStoryblok } from 'storyblok-types';
import { Slide } from 'atoms/Carousel';
import { Container } from 'atoms/Container';
import { Rating } from 'atoms/Rating';
import { Body, Title } from 'atoms/Typography/Typography';
import { Slider } from 'molecules/Slider';
import { NavigationTypes } from 'molecules/Slider/NavigationButtons';
import styles from './styles.module.css';

export const LandingReviewBlock: FC<{ blok: LandingReviewBlockStoryblok }> = ({
  blok,
}) => {
  return !blok ? null : (
    <Container
      style={{
        backgroundColor: blok.backgroundColor.color,
        color: blok.textColor.color,
      }}
      className={styles.root}
    >
      <Title tag="h4" type="lg" className={styles.title}>
        {blok.title}
      </Title>
      <div className={styles.sliderWrapper}>
        <Slider
          slidesPerView={1}
          slidesPerGroup={1}
          spaceBetween={20}
          className={styles.slider}
          pagination={{ enabled: true }}
          navigationType={NavigationTypes.COMPACT}
          loop={true}
          breakpoints={{
            768: {
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
          }}
        >
          {blok.reviewItems.map((item) => (
            <Slide className={styles.slide} key={item._uid}>
              <Rating
                className={styles.icon}
                value={Number(item.numberOfHearts)}
                size="medium"
              />
              <Title type="md" className={styles.reviewText}>
                {item.reviewText}
              </Title>
              <Body type="md">{item.date}</Body>
            </Slide>
          ))}
        </Slider>
      </div>
    </Container>
  );
};
